module.exports = __webpack_public_path__ + "img/elec_charge_offline.00eeaa1f.png";